import { PREPARE_FOR_LOGS_DEFAULT_OPTIONS } from './prepare-for-log/prepare-for-log.js'
import type { makeTelStorage, TelStorageConfig } from './tel-storage.js'

type TelStorage = ReturnType<typeof makeTelStorage>

export interface RootTelConfig {
  sensitiveKeys?: string[]
  storageConfig?: TelStorageConfig
  errorFilterStrings?: string[] // ideally you should produce generic domain errors to encourage users to contact support or give them at least some information. this is a shortcut to silence an error but it's not a good idea to do at scale.
  errorMapper?: (error: unknown) => unknown
}

const initialSensitiveKeys = PREPARE_FOR_LOGS_DEFAULT_OPTIONS.sensitiveKeys

/**
 * makeRootTel's configuration: makeRootTel passes it every key that is not a root span field,
 * so a key added to RootTelConfig arrives here with no edit there. A key this learns to set
 * needs undoing in resetRootTelConfig.
 */
export function applyRootTelConfig(
  storage: TelStorage,
  { sensitiveKeys, storageConfig, errorFilterStrings, errorMapper }: RootTelConfig,
) {
  if (sensitiveKeys) {
    PREPARE_FOR_LOGS_DEFAULT_OPTIONS.sensitiveKeys = sensitiveKeys
  }

  // Update storage configuration including error filter strings and error mapper
  const config = {
    ...storageConfig,
    ...(errorFilterStrings && { errorFilterStrings }),
    ...(errorMapper && { errorMapper }),
  }
  if (Object.keys(config).length > 0) {
    storage.updateConfig(config)
  }
}

/** Tests only: everything applyRootTelConfig set, back to the module's initial values. */
export function resetRootTelConfig(storage: TelStorage) {
  PREPARE_FOR_LOGS_DEFAULT_OPTIONS.sensitiveKeys = initialSensitiveKeys
  storage._resetConfig()
}
